import React from "react";
import PropTypes from "prop-types";

const DefaultAwardIcon = ({ fill, width, height, boxShadow }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M89.5011 46.7587C90.1663 45.6876 90.1663 44.3255 89.5011 43.2412L86.749 38.7981C86.2925 38.0708 86.1491 37.1848 86.3186 36.3517L87.4142 31.2209C87.675 29.9779 87.2185 28.6952 86.2272 27.915L82.1449 24.7017C81.4797 24.1727 81.0363 23.4058 80.919
 22.5462L80.2017 17.3494C80.032 16.0931 79.1583 15.0485 77.9713 14.6518L73.0542 13.0385C72.2457 12.774 71.5675 12.1922 71.1762 11.4384L68.7634 6.79693C68.2025 5.7126 67.0809 5.03819 65.8808 5.03819C65.8417 5.03819 65.8026 5.03819 65.7636 5.03819L60.5986
  5.23655C60.5595 5.23655 60.5204 5.23655 60.4814 5.23655C59.6727 5.23655 58.8902 4.9324 58.2902 4.37701L54.4557 0.859534C53.8427 0.304143 53.0602 0 52.2646 0C51.8472 0 51.4298 0.0793416 51.0386 0.251248L46.2519 2.23479C45.8607 2.39347 45.4434 2.48604
   45.0261 2.48604C44.6087 2.48604 44.1914 2.4067 43.8001 2.23479L39.0135 0.251248C38.6092 0.0925652 38.1918 0 37.7876 0C36.9919 0 36.2093 0.290919 35.5965 0.859534L31.762 4.37701C31.162 4.9324 30.3794 5.23655 29.5708 5.23655C29.5317 5.23655 29.4924
    5.23655 29.4534 5.23655L24.2886 5.03819C24.2495 5.03819 24.2102 5.03819 24.1712 5.03819C22.9713 5.03819 21.8496 5.7126 21.2888 6.79693L18.8759 11.4384C18.4847 12.2054 17.8064 12.774 16.9979 13.0385L12.0809 14.6518C10.8939 15.0352 10.0202 16.0931
     9.8505 17.3494L9.13316 22.5462C9.01591 23.4058 8.57233 24.1727 7.90729 24.7017L3.77281 27.915C2.78145 28.6952 2.32496 29.9779 2.58581 31.2209L3.68138 36.3517C3.86398 37.198 3.70747 38.0708 3.25098 38.7981L0.498877 43.2412C-0.166292 44.3123 -0.166292
      45.6743 0.498877 46.7587L3.25098 51.2018C3.70747 51.9291 3.85094 52.8151 3.68138 53.6482L2.58581 58.7791C2.32496 60.0219 2.78145 61.3048 3.77281 62.085L7.85512 65.2983C8.52029 65.8272 8.96374 66.5941 9.08112 67.4536L9.79846 72.6506C9.96801 73.9069
       10.8419 74.9515 12.0287 75.3482L15.7589 76.5647L16.9588 76.9614C17.7675 77.2259 18.4457 77.8077 18.8369 78.5614L21.2498 83.2029C21.8106 84.2874 22.9322 84.9618 24.1322 84.9618C24.1713 84.9618 24.2105 84.9618 24.2496 84.9618L29.4144 84.7634C29.4536
        84.7634 29.4927 84.7634 29.5318 84.7634C30.3403 84.7634 31.1229 85.0677 31.723 85.623L35.5573 89.1404C36.1703 89.696 36.9529 90 37.7486 90C38.1658 90 38.5832 89.9206 38.9745 89.7487L43.7611 87.7652C44.1524 87.6066 44.5697 87.5142 44.9871 87.5142C45.4043
         87.5142 45.8217 87.5936 46.2129 87.7652L50.9996 89.7487C51.4039 89.9075 51.8212 90 52.2256 90C53.0212 90 53.8037 89.7092 54.4167 89.1404L58.2511 85.623C58.8512 85.0677 59.6337 84.7634 60.4424 84.7634C60.4815 84.7634 60.5206 84.7634 60.5596 84.7634L65.7246
          84.9618C65.7637 84.9618 65.8028 84.9618 65.8418 84.9618C67.0417 84.9618 68.1634 84.2874 68.7244 83.2029L71.1372 78.5614C71.5285 77.7946 72.2066 77.2259 73.0152 76.9614L74.2151 76.5647L77.9453 75.3482C79.1323 74.9647 80.0062 73.9069 80.1757 72.6506L80.8931 67.4536C81.0103
          66.5941 81.4539 65.8272 82.1189 65.2983L86.2014 62.085C87.1926 61.3048
          87.6491 60.0219 87.3882 58.7791L86.2927 53.6482C86.1102 52.802 86.2667 51.9291 86.7232 51.2018L89.5011 46.7587Z"
        fill={fill}
      />
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="2"
        y="0"
        width="86"
        height="90"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.9995 0C24.9632 0 7.98532 13.0948 2.15723 31.1932H87.8418C82.0137 13.0948 65.0359 0 44.9995 0ZM44.9995 89.4886C24.9632 89.4886 7.98532 76.3938
           2.15723 58.2954H87.8418C82.0137 76.3938 65.0359 89.4886 44.9995 89.4886Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          opacity="0.3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M81.818 44.9999C81.818 65.3341 65.3339 81.8181 44.9998 81.8181C24.6657 81.8181 8.18164 65.3341
           8.18164 44.9999C8.18164 24.6658 24.6657 8.18176 44.9998 8.18176C65.3339 8.18176 81.818 24.6658 81.818 44.9999ZM44.9998 79.7727C64.2043 79.7727 79.7725 64.2044 79.7725 44.9999C79.7725 25.7955 64.2043 10.2272 44.9998 10.2272C25.7954 10.2272 10.2271 25.7955 10.2271 44.9999C10.2271 64.2044 25.7954 79.7727 44.9998 79.7727Z"
          fill="white"
        />
        <path
          opacity="0.3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M78.75 45C78.75 63.6396 63.6396 78.75 45 78.75C26.3604 78.75 11.25
           63.6396 11.25 45C11.25 26.3604 26.3604 11.25 45 11.25C63.6396 11.25
            78.75 26.3604 78.75 45ZM45 76.7045C62.5099 76.7045 76.7045 62.5099
             76.7045 45C76.7045 27.4901 62.5099 13.2955 45 13.2955C27.4901 13.2955
              13.2955 27.4901 13.2955 45C13.2955 62.5099 27.4901 76.7045 45 76.7045Z"
          fill="white"
        />
      </g>
      <path
        d="M17.5891 49.2825C17.5891 49.2825 17.4803 51.9813 15.9899 53.4928C15.2447
         54.2485 12.8485 54.0895 12.8485 54.0895C12.8485 54.0895 12.6563 51.6958 
         13.4015 50.9401C14.8921 49.4287 17.5891 49.2825 17.5891 49.2825Z"
        fill="white"
      />
      <path
        d="M7.27917 48.7807C7.27917 48.7807 9.95536 49.1452 11.3185
         50.7724C12.0001 51.5861 11.6143 53.9563 11.6143 53.9563C11.6143
          53.9563 9.21319 53.9204 8.53167 53.1068C7.16862 51.4795 7.27917
           48.7807 7.27917 48.7807Z"
        fill="white"
      />
      <path
        d="M16.7854 42.3536C16.7854 42.3536 16.2766 45.0061 14.578
         46.2793C13.7287 46.9159 11.3828 46.4024 11.3828 46.4024C11.3828 46.4024 11.5486 44.0067 12.3979 43.3702C14.0966 42.0972 16.7854 42.3536 16.7854 42.3536Z"
        fill="white"
      />
      <path
        d="M6.66475 40.3256C6.66475 40.3256 9.257 41.0839 10.3631 42.8957C10.9162 43.8016 10.1823 46.0882 10.1823 46.0882C10.1823 46.0882 7.81315 45.6956 7.26018 44.7897C6.1542 42.9779 6.66475 40.3256 6.66475 40.3256Z"
        fill="white"
      />
      <path
        d="M12.5776 33.9787C12.5776 33.9787 14.1294 36.1893 13.8625 38.2952C13.729 39.3482 11.7283 40.6764 11.7283 40.6764C11.7283 40.6764 10.1225 38.8908 10.256 37.8379C10.5231 35.732 12.5776 33.9787 12.5776 33.9787Z"
        fill="white"
      />
      <path
        d="M72.4109 49.2825C72.4109 49.2825 72.5197 51.9813 74.0101 53.4928C74.7553 54.2485 77.1515 54.0895 77.1515 54.0895C77.1515 54.0895 77.3437 51.6958 76.5985 50.9401C75.1079 49.4287 72.4109 49.2825 72.4109 49.2825Z"
        fill="white"
      />
      <path
        d="M82.7208 48.7807C82.7208 48.7807 80.0446 49.1452 78.6815 50.7724C77.9998 51.5861 78.3856 53.9563 78.3856 53.9563C78.3856 53.9563 80.7868 53.9204 81.4683 53.1068C82.8314 51.4795 82.7208 48.7807 82.7208 48.7807Z"
        fill="white"
      />
      <path
        d="M73.2146 42.3536C73.2146 42.3536 73.7234 45.0061 75.422 46.2793C76.2713 46.9159 78.6172 46.4024 78.6172 46.4024C78.6172 46.4024 78.4514 44.0067 77.6021 43.3702C75.9034 42.0972 73.2146 42.3536 73.2146 42.3536Z"
        fill="white"
      />
      <path
        d="M83.3352 40.3256C83.3352 40.3256 80.743 41.0839 79.6369 42.8957C79.0838 43.8016 79.8177 46.0882 79.8177 46.0882C79.8177 46.0882 82.1868 45.6956 82.7398 44.7897C83.8458 42.9779 83.3352 40.3256 83.3352 40.3256Z"
        fill="white"
      />
      <path
        d="M77.4224 33.9787C77.4224 33.9787 75.8706 36.1893 76.1375 38.2952C76.271 39.3482 78.2717 40.6764 78.2717 40.6764C78.2717 40.6764 79.8775 38.8908 79.744 37.8379C79.4769 35.732 77.4224 33.9787 77.4224 33.9787Z"
        fill="white"
      />
      <path
        opacity="0.75"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.7674 26.5909H37.7422V59.3164H51.7674V26.5909Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.6385 38.2791H27.6133V59.3169H41.6385V38.2791ZM61.897 40.6177H48.651V59.318H61.897V40.6177ZM30.73 42.1751H33.0675V43.7334H30.73V42.1751ZM35.407 42.1759H37.7446V43.7343H35.407V42.1759ZM33.0681 45.2907H30.7305V46.849H33.0681V45.2907ZM35.407 45.2907H37.7446V46.849H35.407V45.2907ZM33.0681 49.188H30.7305V50.7463H33.0681V49.188ZM35.407 49.188H37.7446V50.7463H35.407V49.188ZM33.0681 53.0834H30.7305V54.6417H33.0681V53.0834ZM35.407 53.0834H37.7446V54.6417H35.407V53.0834ZM54.1062 45.2926H51.7687V46.8509H54.1062V45.2926ZM56.4451 45.292H58.7826V46.8504H56.4451V45.292ZM54.1057
         49.1893H51.7681V50.7477H54.1057V49.1893ZM56.4451 49.1893H58.7826V50.7477H56.4451V49.1893ZM54.1057 53.0847H51.7681V54.6431H54.1057V53.0847ZM56.4451 53.0847H58.7826V54.6431H56.4451V53.0847Z"
        fill="white"
      />
    </svg>
  );
};

DefaultAwardIcon.propTypes = {
  /**
   * The color of the award icon
   * Can be any CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
   */
  fill: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  boxShadow: PropTypes.bool
};

DefaultAwardIcon.defaultProps = {
  width: "75%",
  height: 114,
  boxShadow: true
};

export default DefaultAwardIcon;
